import { ajaxSend } from 'api/api';
const BANS_API_BASE = '/v1/bans';
const USERS_API_BASE = `${BANS_API_BASE}/user`;
const IP_API_BASE = `${BANS_API_BASE}/ip`;
const BANS_GROUPED_API_BASE = `${BANS_API_BASE}/users/grouped`;
class BansApi {
    /** Gets the end users bans. */
    getUserBans({ params = {}, path = `${USERS_API_BASE}s`, }) {
        return ajaxSend({
            path,
            params,
        });
    }
    /** Gets the ip address bans. */
    getIpBans({ params = {}, path = `${IP_API_BASE}s` }) {
        return ajaxSend({
            path,
            params,
        });
    }
    getUserBan(userId) {
        return ajaxSend({
            path: `${USERS_API_BASE}/${userId}`,
        });
    }
    getIpBan(ipAddress) {
        return ajaxSend({
            path: `${IP_API_BASE}/${ipAddress}`,
        });
    }
    getBansByUser({ params = {}, path = `${BANS_GROUPED_API_BASE}/user`, }) {
        return ajaxSend({
            path,
            params,
        });
    }
    getBansByIp({ params = {}, path = `${BANS_GROUPED_API_BASE}/ip`, }) {
        return ajaxSend({
            path,
            params,
        });
    }
    /**
     * Bans a user from a channel.
     *
     * @param userId The id of the user to ban.
     * @param data The users ban data.
     */
    banUser(userId, data) {
        return ajaxSend({
            path: `${USERS_API_BASE}/${userId}/ban`,
            method: 'PATCH',
            data,
        });
    }
    /**
     * Bans the ip address.
     *
     * @param ipAddress The ip address to ban.
     * @param data The ip ban data.
     */
    banIp(ipAddress, data = {}) {
        return ajaxSend({
            path: `${IP_API_BASE}/${ipAddress}/ban`,
            method: 'PATCH',
            data,
        });
    }
    /**
     * Unbans the user from a channel.
     *
     * @param userId The id of the user to unban.
     * @param data The users unban data.
     */
    unbanUser(userId, data) {
        return ajaxSend({
            path: `${USERS_API_BASE}/${userId}/unban`,
            method: 'PATCH',
            data,
        });
    }
    /**
     * Unbans the ip address.
     *
     * @param ipAddress The ip address to unban.
     * @param data The ip unban data.
     */
    unbanIp(ipAddress, data = {}) {
        return ajaxSend({
            path: `${IP_API_BASE}/${ipAddress}/unban`,
            method: 'PATCH',
            data,
        });
    }
}
export const bansApi = new BansApi();
